var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',_vm._b({attrs:{"value":_vm.categoryId,"items":_setup.categoryItems,"loading":_setup.categoryLoading,"outlined":"","dense":"","clearable":""},on:{"input":(val) => _vm.$emit('input', val),"scroll":_setup.onScroll}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }